import React from 'react'
import { Form } from 'antd'
import styled from 'styled-components'
import { DEFAULT_REQUIRED_FIELD_MESSAGE } from 'components/Assessments/constants'
import SanitizedInput from 'components/Common/Input/SanitizedInput'
import { InputQuestionProps } from '../types'
import LabelAndDescriptionFieldLayout from '../FieldLayout/LabelAndDescriptionFieldLayout'
import QuestionContainer from '../QuestionContainer'

const Container = styled.div`
  margin: 16px 0;
`

function InputQuestion({
  field,
  formFieldName,
  layout,
  disabled = false,
  required = false,
  customRules = [],
  placeholder,
  type = 'text',
  allowClear = true,
  ...inputProps
}: InputQuestionProps): JSX.Element {
  // Auto-detect description from field extensions
  const secondaryText = field?.extension?.[0]?.valueCodeableConcept?.coding?.[0]?.display

  // Combine default required rule with custom rules
  const allRules = [
    {
      required: Boolean(required && field.required),
      message: DEFAULT_REQUIRED_FIELD_MESSAGE
    },
    ...customRules
  ]

  return (
    <QuestionContainer linkId={field.linkId}>
      <Container>
        <LabelAndDescriptionFieldLayout
          label={field.text}
          secondaryText={secondaryText}
          layout={layout}
        >
          <Form.Item name={formFieldName} rules={allRules} style={{ margin: 0 }}>
            <SanitizedInput
              disabled={disabled}
              placeholder={placeholder}
              type={type}
              allowClear={allowClear}
              {...inputProps}
            />
          </Form.Item>
        </LabelAndDescriptionFieldLayout>
      </Container>
    </QuestionContainer>
  )
}

export default InputQuestion
